import { AxiosResponse } from "axios"

export const responseInterceptorSuccessCredentials = async (
  response: AxiosResponse
) => {
  return response
}

export const responseInterceptorErrorCredentials = async (error: any) => {

  return Promise.reject(error)
}
